import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="contact-info">
        <p>Contact: (570) 798-3098</p>
      </div>
      <div className="social-links">
        <a href="https://www.facebook.com/bramblefarmtherapy" target="_blank" rel="noopener noreferrer">Facebook</a>
        {/* Add other social links as needed */}
      </div>
      <div className="donate">
        <button>Donate</button>
      </div>
      <div className="quote">
        <p>"There is something about the outside of a horse that is good for the inside of a man." – Sir Winston Churchill</p>
      </div>
    </footer>
  );
}

export default Footer;